<div class="d-flex align-items-center justify-content-between">
  <div class="asset-card-content-title">{{ attributeValue.name }}</div>
  <div class="d-flex align-items-center">
    <div class="asset-card-content-value me-3">
      {{ attributeValue.latitude }}, {{ attributeValue.longitude }}
    </div>
    <div
      class="geo-icon"
      (click)="onMapClick()"
      data-bs-toggle="modal"
      data-bs-target="#showMap"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
          fill="var(--primary-color)"
        />
      </svg>
    </div>
  </div>
</div>